'use strict';
var __extends =
	(this && this.__extends) ||
	(function () {
		var extendStatics = function (d, b) {
			extendStatics =
				Object.setPrototypeOf ||
				({ __proto__: [] } instanceof Array &&
					function (d, b) {
						d.__proto__ = b;
					}) ||
				function (d, b) {
					for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
				};
			return extendStatics(d, b);
		};
		return function (d, b) {
			extendStatics(d, b);
			function __() {
				this.constructor = d;
			}
			d.prototype =
				b === null
					? Object.create(b)
					: ((__.prototype = b.prototype), new __());
		};
	})();
var __assign =
	(this && this.__assign) ||
	function () {
		__assign =
			Object.assign ||
			function (t) {
				for (var s, i = 1, n = arguments.length; i < n; i++) {
					s = arguments[i];
					for (var p in s)
						if (Object.prototype.hasOwnProperty.call(s, p))
							t[p] = s[p];
				}
				return t;
			};
		return __assign.apply(this, arguments);
	};
var __rest =
	(this && this.__rest) ||
	function (s, e) {
		var t = {};
		for (var p in s)
			if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
				t[p] = s[p];
		if (s != null && typeof Object.getOwnPropertySymbols === 'function')
			for (
				var i = 0, p = Object.getOwnPropertySymbols(s);
				i < p.length;
				i++
			)
				if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
		return t;
	};
Object.defineProperty(exports, '__esModule', { value: true });
var classNames = require('classnames');
var perfect_scrollbar_1 = require('perfect-scrollbar');
var React = require('react');
var CLASS_NAME = 'i-scrollable';
/**
 * Perfect Scrollbars are used to minimize scrollbars within scrollable areas.
 *
 * Native scrollbars can be used in performance-sensitive areas with the `isNative` prop.
 */
var Scrollable = /** @class */ (function (_super) {
	__extends(Scrollable, _super);
	function Scrollable() {
		var _this = (_super !== null && _super.apply(this, arguments)) || this;
		/**
		 * Initialise PerfectScrollbar and MutationObserver.
		 */
		_this.initialise = function (props) {
			if (!props.isNative) {
				if (_this.scrollableRef) {
					_this.perfectScrollbar = new perfect_scrollbar_1.default(
						_this.scrollableRef,
						props.options
					);
					_this.mutationObserver = new MutationObserver(function () {
						return _this.perfectScrollbar.update();
					});
					_this.mutationObserver.observe(_this.scrollableRef, {
						characterData: true,
						childList: true,
						subtree: true,
					});
				}
			}
		};
		/**
		 * Destroy PerfectScrollbar and disconnect MutationObserver.
		 */
		_this.cleanup = function () {
			if (_this.perfectScrollbar) {
				_this.perfectScrollbar.destroy();
				_this.perfectScrollbar = null;
			}
			if (_this.mutationObserver) {
				_this.mutationObserver.disconnect();
			}
		};
		/**
		 * Moves the node in the subtree, identified by the `selector`,
		 * to be the last child of the container.
		 *
		 * @param selector selector of the element to migrate
		 */
		_this.migrateNodeLast = function (selector) {
			var node = _this.scrollableRef.querySelector(selector);
			if (node) {
				_this.scrollableRef.appendChild(node);
			}
		};
		_this.setScrollableRef = function (ref) {
			_this.scrollableRef = ref;
			if (_this.props.scrollableRef) {
				_this.props.scrollableRef(ref);
			}
		};
		return _this;
	}
	Scrollable.prototype.componentDidMount = function () {
		this.initialise(this.props);
	};
	// We dynamically resize some scrollable containers
	// when that happens we should update the scrollbar rendering
	Scrollable.prototype.componentDidUpdate = function (prevProps) {
		if (
			this.perfectScrollbar &&
			this.props.style &&
			this.props.style !== prevProps.style
		) {
			this.perfectScrollbar.update();
		}
	};
	Scrollable.prototype.componentWillReceiveProps = function (nextProps) {
		var _this = this;
		if (!nextProps.isNative && this.props.isNative) {
			this.initialise(nextProps);
		}
		if (nextProps.isNative && !this.props.isNative) {
			this.cleanup();
		}
		if (!this.props.isNative) {
			// if children are added to the container...
			if (
				React.Children.count(nextProps.children) >
				React.Children.count(this.props.children)
			) {
				// ...make sure the scrollbars are the last nodes.
				setTimeout(function () {
					_this.migrateNodeLast('.ps__rail-x');
					_this.migrateNodeLast('.ps__rail-y');
				});
			}
		}
	};
	Scrollable.prototype.componentWillUnmount = function () {
		this.cleanup();
	};
	Scrollable.prototype.render = function () {
		var _this = this;
		var _a;
		var _b = this.props,
			children = _b.children,
			className = _b.className,
			isNative = _b.isNative,
			options = _b.options,
			scrollableRef = _b.scrollableRef,
			restProps = __rest(_b, [
				'children',
				'className',
				'isNative',
				'options',
				'scrollableRef',
			]);
		return React.createElement(
			'div',
			__assign(
				{
					ref: function (ref) {
						return _this.setScrollableRef(ref);
					},
					className: classNames(
						CLASS_NAME,
						className,
						((_a = {
							ps: !isNative,
						}),
						(_a[CLASS_NAME + '--native'] = isNative),
						_a)
					),
				},
				restProps
			),
			children
		);
	};
	return Scrollable;
})(React.Component);
exports.Scrollable = Scrollable;
//# sourceMappingURL=Scrollable.js.map
